<template>
  <v-layout justify-center>

    <v-dialog v-model="dialog_status"
      class="dialog-container"
      persistent width="800px"
      @keydown.esc="close()">

      <v-card>

        <!-- Title -->
        <v-card-title class="card-title">
          <span>{{ $t('account.billing_details') }}</span>
        </v-card-title>

        <v-card-text>

          <div class="table">
            <div class="table-header">
              <div class="table-row">
                <div class="row-type">
                  {{ $t('account.type') }}
                </div>
                <div class="row-date">
                  {{ $t('account.date') }}
                </div>
                <div class="row-name">
                  {{ $t('account.product_name') }}
                </div>
                <div class="row-kind">
                  {{ $t('account.payment_method') }}
                </div>
                <div class="row-price">
                  {{ $t('account.payment_amount') }}
                </div>
                <div class="row-status">
                  {{ $t('account.payment_status') }}
                </div>
              </div>
            </div>
            <div class="table-contents">
              <div class="table-row"
                v-for="p in payments" :key="p.pay_id">
                <div class="row-type" v-if="!!p.auto_pay_id">
                  정기결제
                </div>
                <div class="row-type" v-else>
                  일반결제
                </div>
                <div class="row-date">
                  {{ p.created_ts.substr(0,10) }}
                </div>
                <div class="row-name">
                  {{ $t('plans.' + p.product_name) }}
                </div>
                <div class="row-kind" v-if="p.kind==3">
                  {{ $t('payment.' + p.pgcode) }}
                </div>
                <div class="row-kind" v-else>
                  {{ payment_kinds[p.kind].name }}
                </div>
                <div class="row-price">
                  {{ $t('payment.price_KRW', [p.amount]) }}
                </div>
                <div class="row-status">
                  {{ $t('account.' + payment_status[p.status].name) }}
                </div>
              </div>
            </div>
          </div>

          <div class="meta" v-if="is_cashwait">
            ※ 결제 대기 중인 상품이 있습니다. 결제를 완료하시려면 해당 금액을 100-033-372182 (신한은행, 예금주: 비블리오트리즈주식회사)로 입금해주세요. 결제 요청을 취소하시려면 <a href="mailto: services@bibliotrees.net">문의</a>로 알려주세요.
          </div>

        </v-card-text>

        <!-- Actions -->
        <v-card-actions class="actions">
          <v-spacer></v-spacer>
          <div class="buttons">
            <v-btn small text @click="close()">
              {{ $t('actions.close') }}
            </v-btn>
          </div>
        </v-card-actions>

      </v-card>

    </v-dialog>

  </v-layout>
</template>

<script>
import { payment_kinds, payment_status } from '../../../custom/model.js'

export default {
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      payment_kinds,
      payment_status,
      payments: [],
    }
  },

  computed: {
    dialog_status: {
      get: function(value) {
        return this.dialog
      },
      set: function(value) {
        if (!value) { this.close() }
      },
    },

    is_cashwait() {
      return this.payments.some(v => v.status == 5)
    }
  },

  async created() {
    try {
      await this.$store.dispatch('user/getMyPayments')
    } catch(e) {
      this.$store.commit('error/setDialog', true)
      this.$store.commit('error/setErrorCode', e.response.status)
    } finally {
      this.payments = this.$store.getters['user/payments']
    }
  },

  methods: {
    close() {
      this.$emit('update:dialog', false)
    },
  },

}
</script>

<style scoped>

  .table {
    padding: 0 40px;
    display: flex;
    flex-direction: column;
  }

  .table-header {
    border-bottom: solid 1px #818387;
    color: #818387;
  }

  .table-row {
    display: grid;
    grid-template-columns: 15% 15% 15% 15% 15% 15%;
    grid-column-gap: 2%;
  }

  .table-row > div {
    padding: 8px;
    display: flex;
    align-items: center;
  }

  .meta {
    margin: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/components/modal/account/BillingActivity.vue